/** Copy some text to the clipboard */
export function copyToClipboard(text: string) {
  const el = document.createElement('textarea');
  el.value = text;
  document.body.appendChild(el);
  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);
}

export const sleep = (ms: number): Promise<void> =>
  new Promise((r) => setTimeout(r, ms));

export function getLayoutContentHeight(): number {
  const hasAnnouncements = document.getElementById('grabx-announcements');
  const vwHeight = window.innerHeight;
  const paddings = 24 * 2;
  const gap = 16 * 2;

  if (!hasAnnouncements) return vwHeight - paddings;

  const announcementsHeight = hasAnnouncements.offsetHeight;

  return vwHeight - paddings - gap - announcementsHeight;
}

export const enum BROWSER_TARGET {
  SELF = '_self', // Opens the linked document in the same frame as it was clicked (this is default)
  BLANK = '_blank', // Opens the linked document in a new window or tab
}
